import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'CONFIG_DETAIL',
        create: 'CONFIG_CREATE',
        update: 'CONFIG_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'config_name',
        default: '',
        label: '参数名称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.config_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "config_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'config_key',
        default: '',
        label: '参数键名',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.config_key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "config_key", $$v);
              }
            }
          });
        }
      }, {
        prop: 'config_value',
        default: '',
        label: '参数键值',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.config_value,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "config_value", $$v);
              }
            }
          });
        }
      }, {
        prop: 'config_type',
        default: this.$env.VUE_APP_DICT_IS_TRUE,
        label: '系统内置',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "is",
              "button": true
            },
            "model": {
              value: _this.form.model.config_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "config_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};